import { Order } from "../enums/order.enum";


export class RequestSort {
  Name: string;
  Order: Order;
  Position: number;
}
